module.exports = __webpack_public_path__ + "user.01cfe3e021c1b99dd4eb4a4b65a2dc80.svg";